import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import BoxEditIco from "../../../assets/icons/BoxEditIco";
import DeleteIco from "../../../assets/icons/DeleteIco";
import CommonButton from "../../../component/Button";
import {
  CommonGrid2,
  StyledFlexColumnView,
} from "../../common-components/StyledComponents";
import { CustomPaper } from "../../resume-intelligence/Style";
import { HandleSkeletion } from "../../../utils/constants";
import CoversheetExclamatoryIco from "../../../assets/icons/CoversheetExclamatoryIco";
import { CustomizeSpan } from "../../jobs/style";
import { useFormikContext } from "formik";
import { CoversheetUpload } from "../../common-components/CoverSheetFunction";

function Experience({
  data,
  title,
  loading,
  handleExperienceEdit,
  handleExperienceDelete,
  form,
  view_resume,
  handleAnotherFunction,
}) {
  const { values, errors, setFieldValue, handleChange } = useFormikContext();
  const lg = useMediaQuery("(min-width:767px)");

  return loading ? (
    <HandleSkeletion height={80} />
  ) : (
    <Box>
      {data.map((item, index) => {
        return (
          <CustomPaper
            variant="outlined"
            marginBottom="10px"
            display={"flex"}
            alignItems={"center"}
            padding={"12px"}
          >
            <CommonGrid2
              display={"flex"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                width={"100%"}
              >
                {/* <CustomImg
                src={item.icon}
                width={"48px"}
                height={"48px"}
                alt="logo"
              /> */}
                <StyledFlexColumnView gap={"4px"}>
                  <Typography
                    variant={lg ? "h5" : "subtitle3"}
                    fontWeight={600}
                    color={"#101828"}
                  >
                    {item?.job_title}
                  </Typography>
                  <Typography
                    variant={lg ? "subtitle1" : "subtitle2"}
                    fontWeight={400}
                    color={"#475467"}
                  >
                    {item?.company} &nbsp;&nbsp;&nbsp;
                    {item?.start_date}
                    {item?.start_date && item?.end_date && " - "}
                    {item?.end_date}
                  </Typography>
                </StyledFlexColumnView>
              </Stack>
              {item?.accomplishments_summary === undefined && (
                <CommonGrid2
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  gap={"10px"}
                  minWidth={"fit-content"}
                >
                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    borderRadius={"6px"}
                    padding={lg ? "11px" : "5px"}
                    border="#D0D5DD"
                    fontWeight="600"
                    minWidth="auto"
                    svg={true}
                    disabled={
                      item?.accomplishments_summary !== undefined || view_resume
                    }
                    value={<BoxEditIco />}
                    onClick={() => handleExperienceEdit(item, index, form)}
                  />

                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    borderRadius={"6px"}
                    padding={lg ? "11px" : "5px"}
                    border="#D0D5DD"
                    fontWeight="600"
                    minWidth="auto"
                    value={<DeleteIco />}
                    svg={true}
                    disabled={
                      item?.accomplishments_summary !== undefined || view_resume
                    }
                    onClick={() =>
                      handleExperienceDelete(title, item, index, form)
                    }
                  />
                </CommonGrid2>
              )}
            </CommonGrid2>
          </CustomPaper>
        );
      })}

      <CommonGrid2
        display={"flex"}
        background={"#F7F8F9"}
        borderRadius={"10px"}
        padding={"1rem"}
        flexDirection={lg ? "row" : "column"}
        gap={"10px"}
        width={lg ? "90%" : "100%"}
        margin={"auto"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <CommonGrid2 display={"flex"} gap={"10px"}>
          <CommonGrid2 display={"flex"} minWidth={"fit-content"}>
            <CoversheetExclamatoryIco />
          </CommonGrid2>
          <Typography variant={lg ? "body1" : "subtitle3"}>
            <CustomizeSpan fontWeight={700}>Note:</CustomizeSpan> Please attach
            your current resume to update your experience information.
          </Typography>
        </CommonGrid2>
        <CoversheetUpload
          values={values}
          disabled={view_resume || values?.["resume_upload"]?.length !== 0}
          setFieldValue={setFieldValue}
          item={{
            titleName: "resume_upload",
            single_upload: true,
            file_name: "Resume",
          }}
          handleAnotherFunction={handleAnotherFunction}
        />
      </CommonGrid2>
    </Box>
  );
}

export default Experience;
